import { z } from 'zod'

import { CoordsSchema } from '@/ducks/common.schema'

const AddressSchema = z.object({
  lng: z.number().min(-180).max(180),
  lat: z.number().min(-90).max(90),
  line1: z.string().min(1),
  city: z.string().min(1),
  state: z.string().min(1),
  country: z.string().min(1),
  country_code: z.string().min(1),
  currency_symbol: z.string().optional()
})

const CountrySchema = z.object({
  name: z.string(),
  code: z.string()
})

const CitySchema = z.object({
  cityname: z.string(),
  country_code: z.string().optional(),
  location: CoordsSchema.optional()
}).passthrough()
const CuisineSchema = z.object({
  name: z.string(),
  _id: z.string()
})
const RestaurantSchema = z.unknown()

const ApiGetCitySchema = z.tuple([
  z.array(CitySchema),
  z.array(CuisineSchema),
  z.array(RestaurantSchema),
  z.array(z.object({ country: CountrySchema }))
])

const ApiGetSubCitySchema = z.tuple([
  z.unknown(),
  z.union([z.literal(0), z.array(CuisineSchema)])
])

const ApiRegistrationValidationError = z.object({
  param: z.string(),
  msg: z.string()
})

const ApiRegistrationErrorSchema = z.union([
  z.object({
    errors: z.array(ApiRegistrationValidationError).optional()
  }),
  z.object({ message: z.string() })
])

const ApiRegistrationDTOSchema = z.object({
  email: z.string().email(),
  phone: z.string(),
  address: AddressSchema,
  resname: z.string(),
  username: z.string(),
  main_city: z.string(),
  main_cuisine: z.array(CuisineSchema),
  password: z.string(),
  cpwd: z.string()
})

export {
  ApiGetCitySchema,
  ApiGetSubCitySchema,
  ApiRegistrationDTOSchema,
  ApiRegistrationErrorSchema,
  CitySchema,
  CountrySchema,
  CuisineSchema
}
